import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, IconButton, Alert } from '@mui/material';
import { Typography, Button } from 'components/index';
import CloseIcon from '@mui/icons-material/Close';
import { joinDateAndUser } from 'common/utils/common.util';
import { NoteDTO } from 'common/utils/util.type';

interface LineItemNoteDialogProps {
  open: boolean;
  onClose?: () => void;
  onSave?: (noteContent: string) => void;
  isLoading: boolean;
  note?: NoteDTO;
  lineItem?: string;
}

const LineItemNoteDialog: React.FC<LineItemNoteDialogProps> = ({ open, onClose, onSave, isLoading, note, lineItem }) => {
  const [noteContent, setNoteContent] = useState(note?.content || '');
  const handleSave = () => {
    onSave?.(noteContent); // Call onSave if it's defined and pass the note content
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle>
        {lineItem}
        <IconButton aria-label='close' onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '24px' }}>
        <TextField
          multiline
          rows={6}
          fullWidth
          value={noteContent}
          onChange={e => setNoteContent(e.target.value)}
          placeholder='Add a note...'
        />
        {note?.updatedOn || note?.createdOn ? (
          <Typography variant='subtitle2' fontSize='small'>
            Last Edited :{' '}
            {note?.updatedOn && note?.updatedBy
              ? joinDateAndUser(note.updatedOn, note.updatedBy)
              : joinDateAndUser(note?.createdOn, note?.createdBy)}
          </Typography>
        ) : null}
      </DialogContent>
      <Alert severity='warning' sx={{ margin: '0px 24px' }}>
        You need to click <b>Submit Changes</b> to avoid losing your changes!
      </Alert>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button variant='outlined' onClick={onClose} color='secondary'>
          Cancel
        </Button>
        <Button
          variant='contained'
          disabled={isLoading} // Disable the button when loading
          startIcon={isLoading && <CircularProgress size={24} color='inherit' />}
          onClick={handleSave}
          color='primary'
        >
          Save Draft
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(LineItemNoteDialog);
